/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Form buttons for the DateRangeInput
 */

import { ChevronLeft, ChevronRight } from '@zcode-ui/icons'
import addMonths from 'date-fns/addMonths'
import subMonths from 'date-fns/subMonths'
import React, { ReactNode, ReactNodeArray } from 'react'

import * as style from '../style'
import { SetStateDate } from '../types'
export interface CalendarArrowButtonsProps {
  hideFirstArrow?: boolean
  hideSecondArrow?: boolean
  setTargetMonth: SetStateDate
  targetMonth: Date
  children: ReactNode | ReactNodeArray
}

export const CalendarArrowButtons = ({
  hideFirstArrow,
  hideSecondArrow,
  setTargetMonth,
  targetMonth,
  children,
}: CalendarArrowButtonsProps) => (
  <div css={style.calendarArrowContainer}>
    <div>
      <button
        aria-label="Previous Month"
        css={[style.arrowButtonLeft, hideFirstArrow && style.arrowButtonHidden]}
        onClick={() => setTargetMonth(subMonths(targetMonth, 1))}
        type="button"
      >
        <ChevronLeft />
      </button>
    </div>
    {children}
    <div>
      <button
        aria-label="Next Month"
        css={[style.arrowButtonRight, hideSecondArrow && style.arrowButtonHidden]}
        onClick={() => setTargetMonth(addMonths(targetMonth, 1))}
        type="button"
      >
        <ChevronRight />
      </button>
    </div>
  </div>
)
